// Attribute names for the form submission index's columns and groupings,
// from :activity_hub_index view in app/serializers/form_submission_blueprint.rb.
//
// Not every serialized field has a constant here — only ones used as a
// column or grouping. Nothing enforces the match, so renaming a field in
// the blueprint requires renaming it here too.
export const BATCH_SENT_AT = "batchSentAt"
export const CONVERSATIONS_COUNT = "conversationsCount"
export const CREATED_AT = "createdAt"
export const FORM = "form"
export const IMPORTANT = "important"
export const SLUG = "slug"
export const STATUS_NAME = "statusName"
export const SUBMITTER_FULL_NAME = "submitterFullName"
export const TASKS_COUNT = "tasksCount"
export const UPDATED_AT = "updatedAt"
